import { OrganizationUser } from '@enview/interface/types/OrganizationUser';
import { Team, TeamMembership } from '@enview/interface/types/Team';

const filteredTeamMembershipsForSelector = (
  teamMeberships?: TeamMembership[],
  orgUser?: OrganizationUser,
  teamModeOrgId?: number,
): Team[] => {
  if (!teamMeberships || !teamModeOrgId || !orgUser || teamMeberships.length === 0) {
    return [];
  }
  return teamMeberships
    .map((tm) => tm.team)
    .sort((team1, team2) => {
      const userTeamId = orgUser && orgUser.teamId;
      if (team1.id === userTeamId) {
        return -1;
      }
      if (team2.id === userTeamId) {
        return 1;
      }
      return team1.name.localeCompare(team2.name);
    })
    .filter(
      (team) =>
        team.organizationId === teamModeOrgId ||
        (orgUser && team.id === orgUser.teamId),
    );
};

export default filteredTeamMembershipsForSelector;
